import React from 'react';
import { useLoginModel } from './model';
import { LoginView } from './view';

export const LoginWidget: React.FC = () => {
  const { loading, submit } = useLoginModel();

  return <LoginView loading={loading} onSubmit={submit} />;
};
